<template>
  <Box>
    <Header
      :type="type"
      :status="status"
      :route="route"
    />

    <Success
      :type="type"
      :status="status"
      :height="cardBodyHeight"
      :items="items"
      @openGlobalDrawer="openGlobalDrawer"
    />

    <Error
      :status="status"
      :height="cardBodyHeight"
      @tryAgain="tryAgain"
    />

    <Loading :status="status" :height="cardBodyHeight" />
  </Box>
</template>

<script>
import Header from './Header'
import Success from './Success'
import Error from './Error'
import Loading from './Loading'

export default {
  name: 'Top5',
  props: {
    type: {
      type: String
    },
    route: {
      type: Object
    },
    items: {
      type: [Array, null]
    },
    status: {
      type: String,
      default: 'loading'
    },
    minHeight: {
      type: Number,
      default: 0
    }
  },
  components: {
    Header,
    Success,
    Error,
    Loading
  },
  computed: {
    cardBodyHeight () {
      const cardHeader = document.querySelector('[data-id="cardHeader"]')
      return !cardHeader ? this.minHeight : this.minHeight - cardHeader.offsetHeight
    }
  },
  methods: {
    tryAgain () {
      this.$emit('tryAgain')
    },

    openGlobalDrawer (obj) {
      this.$emit('openGlobalDrawer', obj)
    }
  }
}
</script>
